module.exports = __webpack_public_path__ + "img/s1.85eb3017.png";